<template>
  <textarea :key="field_idx"
              class="full-width tip radius"
              :required="field.required"
              :disabled="field.disabled"
              :data-idx="field_idx"
              :readonly="field.readonly"
              v-model="current_value"
              :data-original-title="field.help"
              data-placement="bottom"
              data-toggle="tooltip"
              :placeholder="field.placeholder">
</textarea>

</template>

<script>
export default {
  name:"CustomTextArea",
  props:["field", "value","field_idx"],
  data() {
    return {
      current_value:null,
    }
  },
  created()
  {
    this.current_value = this.value
  },
  methods:{
    updateFromTextArea(){
      this.$emit("field-updated", {type:this.field.type, idx:this.field_idx, new_value:this.current_value})
    }
  },
  watch:
  {
    current_value(){
      this.updateFromTextArea()
    }
  }
}
</script>

<style scoped>

.radius {
  border-radius: 2px;
  border-color:rgba(0, 0, 0, 0.07)
}

</style>



// WEBPACK FOOTER //
// client/components/Forms/Elements/TextArea.vue